module.exports = __webpack_public_path__ + "static/media/1005107.b09b20cf.png";